// src/media/provider/media-provider-context.ts
import { createContext, writable } from "@vidstack/foundation";
var mediaProviderElementContext = createContext(
  () => writable(void 0)
);

export {
  mediaProviderElementContext
};
